import type { ConsentTypeName, DocumentKind } from '@/shared/api';

/** Ausweis- und Dokumentart (gleiche Werte) in Worten statt `Passport`/`IdCard`. */
export const ID_KIND_LABEL: Record<DocumentKind, string> = {
  Passport: 'Reisepass',
  IdCard: 'Personalausweis',
  Other: 'Sonstiges Dokument',
};

export const CONSENT_LABEL: Record<ConsentTypeName, string> = {
  DataProcessing: 'Datenverarbeitung',
  Marketing: 'Werbung',
  PassportStorage: 'Speicherung des Ausweises',
  HouseRules: 'Hausordnung',
};
